import React from "react";
import { Modal, Box } from "@mui/material";
import AudioRecorderModal from "../audioRecorderModal/AudioRecorderModal";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  maxWidth: "90vw",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 44,
  height: "auto", // Allow height to adjust based on content
  maxHeight: "90vh", // Prevent the popup from getting too tall
  overflowY: "auto", // Allow scrolling if content exceeds max height
};

const CartAudioRecorderModal = ({ open, onClose, baseUrl, cartNumber }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={modalStyle}>
        <AudioRecorderModal baseUrl={baseUrl} onClose={onClose} cartNumber={cartNumber} />
      </Box>
    </Modal>
  );
};

export default CartAudioRecorderModal;
